export const TR_EN = {
  // SEO overhaul: directory, pagination, profile facts
  lawyers_level_label: "Bar level",
  lawyers_all_levels: "All levels",
  lawyers_by_governorate: "Lawyers by governorate",
  lawyers_page_of: "Page {{page}} of {{pages}}",
  lawyers_empty_level: "No lawyers at this bar level in this governorate.",
  pagination_label: "Pages",
  pagination_prev: "Previous",
  pagination_next: "Next",
  breadcrumb_label: "Breadcrumb",
  profile_bar_level: "Bar level",
  profile_sworn_in: "Sworn in",
  profile_bar_section: "Regional section",
  profile_office_address: "Office address",
  profile_city: "Governorate",
  profile_other_lawyers: "Other lawyers in {{city}}",
  profile_claim: "Are you this lawyer? Claim your profile",
  // Questions & answers pages redesign
  qa_latest: "Latest questions",
  qa_eyebrow: "Questions & answers",
  qa_ask: "Ask a question",
  qa_ask_text: "Put your question to the lawyers registered on the platform.",
  qa_read_answers: "Read the answers",
  qa_no_answers: "No answers yet.",
  qa_no_answers_text: "Lawyers registered on the platform can answer this question.",
  qa_lawyer_badge: "Lawyer",
  qa_back: "All questions",
  qa_empty: "No published questions yet.",
  qa_question_label: "Question",
  qa_answer_error: "Your answer couldn't be posted. Please try again.",
  qa_save: "Save",
  // Lawyer dashboard redesign
  ldash_hello: "Hello, {{name}}",
  ldash_lead: "Manage your appointment requests, schedule and answers in one place.",
  ldash_stat_pending: "Pending requests",
  ldash_public_profile: "View my public profile",
  ldash_username_add: "Add a username",
  ldash_username_placeholder: "Unique username",
  ldash_decline: "Decline",
  ldash_confirm_accept: "Accept this appointment?",
  ldash_confirm_decline: "Decline this appointment?",
  ldash_empty_list: "Nothing in this list yet.",
  ldash_premium_text: "Your profile is visible and clients can book appointments with you online.",
  ldash_free_text: "Your profile, phone number, opening hours and address are visible in the directory. Try Pro for 14 days, no card needed, for online booking and case files.",
  case_menu: "Cases",
  case_title: "Cases",
  dl_title: "Hearings and deadlines",
  dl_add: "Add a deadline",
  dl_hint: "Email reminder 7 days, then 1 day before. A shared deadline is also sent to your client the day before.",
  dl_f_kind: "Type",
  dl_f_label: "Details",
  dl_f_date: "Date",
  dl_f_time: "Time",
  dl_f_location: "Place (court, room)",
  dl_share: "Show this date to {{name}} and remind them the day before",
  dl_save: "Save deadline",
  dl_empty: "No hearings or deadlines in this case.",
  dl_kind_hearing: "Hearing",
  dl_kind_appeal: "Appeal deadline",
  dl_kind_filing: "Filing",
  dl_kind_meeting: "Meeting",
  dl_kind_other: "Deadline",
  dl_done: "Done",
  dl_mark_done: "Mark as done: {{what}}",
  dl_shared: "Shared",
  dl_shared_hint: "Visible to the client, reminded the day before",
  dl_today: "Today",
  dl_tomorrow: "Tomorrow",
  dl_in_days_one: "In {{count}} day",
  dl_in_days: "In {{count}} days",
  dl_late_one: "{{count}} day late",
  dl_late: "{{count}} days late",
  dl_upcoming_title: "Upcoming hearings and deadlines",
  dl_upcoming_empty: "Nothing in the next 30 days. Add your hearings to your cases to be reminded in time.",
  dl_more: "+ {{count}} more in your cases",
  case_notes_title: "Notes",
  pstats_deadlines_one: "{{count}} deadline this week",
  pstats_deadlines: "{{count}} deadlines this week",
  pstats_overdue_one: "{{count}} overdue",
  pstats_overdue: "{{count}} overdue",
  mycases_dates: "Dates to remember",
  pro_f_deadlines: "Hearings and deadlines",
  pro_f_deadlines_text: "Record hearings and appeal deadlines: email reminders 7 days and 1 day before, for you and, if you choose, your client.",
  pro_c_deadlines: "Hearing and deadline reminders",
  case_lead: "One file per matter. Notes are private and encrypted; you choose which ones your client can read.",
  case_new: "New case",
  case_f_title: "Title",
  case_f_reference: "Reference",
  case_f_category: "Area",
  case_f_client: "Client",
  case_f_status: "Status",
  case_no_client: "No linked client",
  case_client_hint: "Only clients who booked an appointment with you can be linked to a case.",
  case_create: "Create case",
  case_all: "All",
  case_status_open: "Open",
  case_status_pending: "On hold",
  case_status_closed: "Closed",
  case_cat_civil: "Civil",
  case_cat_family: "Family",
  case_cat_criminal: "Criminal",
  case_cat_commercial: "Commercial",
  case_cat_labor: "Employment",
  case_cat_administrative: "Administrative",
  case_cat_real_estate: "Real estate",
  case_cat: "Other",
  case_empty: "No cases yet.",
  case_error: "That didn't work. Please try again.",
  case_back: "All cases",
  case_note_new: "New note",
  case_note_share: "Share this note with {{name}}",
  case_note_share_no_client: "Link a client to the case to share notes.",
  case_note_privacy: "Notes are encrypted and covered by professional secrecy. A shared note is visible to your client only, never published; they get an email without its content.",
  case_note_add: "Add note",
  case_notes_empty: "No notes in this case.",
  case_note_shared: "Shared with the client",
  case_note_private: "Private",
  case_note_do_share: "Share with the client",
  case_note_unshare: "Stop sharing",
  case_delete: "Delete case",
  case_delete_confirm: "Permanently delete this case and all its notes?",
  case_delete_yes: "Yes, delete",
  clients_menu: "Clients",
  clients_title: "Clients",
  clients_lead: "People who booked with you, each with a private memo only you can see.",
  clients_empty: "Your clients will appear here after their first online booking.",
  clients_appointments_one: "{{count}} appointment",
  clients_appointments: "{{count}} appointments",
  clients_last: "Last: {{date}}",
  clients_cases: "Cases: {{count}} ({{open}} open)",
  clients_memo: "Private memo",
  clients_memo_save: "Save",
  clients_memo_saved: "Saved",
  clients_open_case: "Open a case",
  fb_menu: "Client feedback",
  fb_title: "Client feedback",
  fb_lead: "What your clients say after their consultation. Visible to you only: never published, never used to rank lawyers.",
  fb_count_one: "{{count}} review",
  fb_count: "{{count}} reviews",
  fb_empty: "No feedback yet. Clients can leave some after a confirmed consultation.",
  fb_rating_one: "{{count}} star out of 5",
  fb_rating: "{{count}} stars out of 5",
  fb_give: "Give the lawyer feedback",
  fb_give_title: "How was the consultation?",
  fb_comment: "A word for your lawyer (optional)",
  fb_private_note: "Visible to your lawyer only. Never published on the site.",
  fb_send: "Send",
  fb_given: "Feedback sent",
  pstats_title: "Your practice",
  pstats_cases_open: "Open cases",
  pstats_cases_pending: "On hold",
  pstats_cases_closed: "Closed",
  pstats_upcoming: "Upcoming appointments",
  pstats_last30: "Last 30 days: {{opened}} opened, {{closed}} closed",
  pstats_avg_close_one: "closed in {{count}} day on average",
  pstats_avg_close: "closed in {{count}} days on average",
  pstats_feedback: "client feedback {{average}}/5 ({{count}})",
  pstats_open_cases: "See cases",
  pstats_locked: "Track your cases, appointments and client feedback in one place.",
  mycases_tab: "My cases",
  mycases_empty: "No cases. When your lawyer opens a case for you on AvoConsulte, you'll find it here.",
  mycases_lawyer: "{{name}}, lawyer",
  mycases_no_notes: "Your lawyer hasn't shared anything on this case yet.",
  ldash_last_answer: "Last answer",
  // User dashboard redesign
  dash_wrong_email: "Not your email address?",
  dash_virtual: "Online",
  dash_hello: "Hello, {{name}}",
  dash_lead: "Follow your appointments and legal questions in one place.",
  dash_stat_upcoming: "Upcoming appointments",
  dash_stat_pending: "Questions awaiting review",
  dash_question_sent: "Your question was sent. It will be published after review.",
  dash_question_error: "Your question couldn't be sent. Please try again.",
  dash_email_note: "Your email can't be changed from this page.",
  dash_saving: "Saving…",
  dash_verify_text: "We sent a verification link to {{email}}. Open it to activate your account.",
  dash_sending: "Sending…",
  // About & contact pages redesign
  about_title: "What is AvoConsulte?",
  about_lead: "AvoConsulte is a simple, fast way to find a lawyer near you in the directory and book an appointment with them.",
  about_clients_title: "For clients",
  about_clients_1: "Quickly find a lawyer near you and book an appointment online, free of charge.",
  about_clients_2: "Ask your legal questions online, directly to lawyers, in confidence.",
  about_clients_3: "Read the answers lawyers have already given to other users' questions.",
  about_lawyers_title: "For lawyers",
  about_lawyers_1: "A complete practice-management tool that improves your organisation and saves you time.",
  about_lawyers_2: "Share your availability with clients in real time, on your own terms, while keeping control of your schedule.",
  about_lawyers_3: "Talk to your clients directly and answer their questions.",
  contact_eyebrow: "Contact",
  contact_title: "We're here to help",
  contact_form_title: "Send us a message",
  contact_sending: "Sending…",
  contact_success: "Thank you for contacting us. We'll get back to you as soon as possible.",
  contact_error: "Your message couldn't be sent. Please try again later or email us.",
  contact_email_title: "Email us",
  contact_find_lawyer_title: "Looking for a lawyer?",
  contact_find_lawyer_text: "Browse the directory by governorate or by name.",
  contact_question_title: "A legal question?",
  contact_question_text: "Ask lawyers in the legal advice section.",
  // Lawyer profile page redesign
  Maps: "Office location",
  profile_call: "Call the lawyer",
  profile_fax: "Fax",
  profile_no_online_booking: "This lawyer doesn't offer online booking yet. You can contact them by phone.",
  profile_hours_indicative: "Indicative hours, please confirm by phone.",
  profile_open_map: "Open in Google Maps",
  profile_court: "Bar level",
  // Magazine & lawyers pages redesign
  magazine_eyebrow: "Articles & practical guides",
  magazine_author: "AvoConsulte editorial team",
  read_article: "Read the article",
  back_to_magazine: "Back to the magazine",
  lawyers_eyebrow: "Lawyers directory",
  lawyers_title: "Lawyers in {{state}}",
  lawyers_title_all: "Lawyers across Tunisia",
  lawyers_change_search: "Try another name or search all of Tunisia.",
  // Home page redesign
  home_eyebrow: "The directory of lawyers in Tunisia",
  home_search_name_label: "Lawyer's name",
  home_search_city_label: "Governorate",
  home_all_cities: "All of Tunisia",
  home_popular_cities: "Popular cities",
  home_trust_states: "24 governorates",
  home_trust_booking: "Online appointment booking",
  home_trust_advice: "Legal advice from lawyers",
  home_steps_eyebrow: "How it works",
  home_step1_title: "Find a lawyer",
  home_step2_title: "Book an appointment",
  home_step3_title: "Get a reminder",
  home_cta_title: "Are you a lawyer?",
  home_cta_text: "Join AvoConsulte and receive appointment requests from clients online.",
  home_cta_button: "Join AvoConsulte",
  // ?Home Search component
  find_lawyer_near_you: "Find a lawyer near you",
  find_lawyer_near_you_description:
    "Search and find a lawyer, book your appointment today.",
  search: "Search",
  city: "City",
  based_on_your_location: "Based on your location",
  ex: "exemple : lawyer name",
  search_location: "Search Location",
  // ?Navbar component
  Home: "Home",
  LegalMagazine: "Legal Magazine",
  LegalAdvice: "Legal Advice",
  Lawyers: "Lawyers",
  AboutUs: "About Us",
  ContactUs: "Contact Us",
  PrivacyPolicy: "Privacy Policy",
  Legal_Magazine: "Legal-Magazine",
  Legal_Advice: "Legal-Advice",
  About_Us: "About-Us",
  Contact_Us: "Contact-Us",
  Privacy_Policy: "Privacy",
  Login: "Login",
  arabic: "Arabic",
  french: "French",
  english: "English",
  my_account: "My Account",
  nav_open_menu: "Open menu",
  nav_close_menu: "Close menu",
  nav_menu: "Menu",
  nav_language: "Language",
  theme_label: "Appearance",
  theme_dark: "Dark mode",
  theme_light: "Light mode",
  footer_navigation: "Navigation",
  footer_by_city: "Lawyers by governorate",
  footer_your_space: "Your space",
  privacy_eyebrow: "Privacy",
  privacy_title: "Privacy Policy",
  privacy_lead:
    "The security and confidentiality of your personal data is an absolute priority for AvoConsulte.",
  privacy_intro:
    "AvoConsulte builds strong and lasting relationships with its users, based on mutual trust. This page explains what information is collected when you use the platform and how it is used.",
  privacy_toc: "Contents",
  privacy_logs_title: "Login records",
  privacy_logs_body:
    "AvoConsulte may keep full login records: your IP address, browser type, browsing time, length of stay, access date and the links you visited. This helps us understand the nature of our visitors and improve the service continuously. It is never used, promoted or exposed to other visitors or users as personal information.",
  privacy_cookies_title: "Cookies",
  privacy_cookies_body:
    "We sometimes use cookies to learn visitors' preferences, the history of their visits and the links they followed. They may be stored without affecting the subscriber's privacy or personal information.",
  privacy_third_title: "Third-party sites",
  privacy_third_body:
    "AvoConsulte displays Google ads and uses third-party site services, so your cookies may be used to show ads that match your interests. Those sites, most notably Google, may use your IP address to analyse cookies and measure how effective ads are. To understand this or to opt out, see Google's explanations:",
  privacy_third_link: "Google ad settings",
  privacy_consulting_title: "Consulting services",
  privacy_consulting_body:
    "AvoConsulte provides a private advisory service, so our team of advisors and other parties can learn the facts and progress of your legal case. AvoConsulte does not publish any case or information on its platform without the parties' prior consent, through the option shown in the consultation window. Private consultations go to an e-mail address that is not visible to the public and is reserved for the advisory team, unless the subscriber chooses to make the question public.",
  privacy_updates_title: "Updates",
  privacy_updates_body:
    "Please read this policy from time to time. If you have a question, write to us at the main e-mail address on the site. The policy may change on the instructions of our legal team: if it does, we will send a copy to our subscribers or display a notice on our home pages.",
  privacy_contact_title: "A question about your data?",
  privacy_contact_text: "Our team is available by e-mail.",
  privacy_contact_btn: "Contact us",
  // Operation Center (operators' console)
  oc_title: "Operation Center",
  oc_login_lead: "For the AvoConsulte team only.",
  oc_email: "Email",
  oc_password: "Password",
  oc_continue: "Continue",
  oc_code: "Verification code",
  oc_code_lead: "Enter the 6-digit code sent to {{email}}.",
  oc_code_dev: "Development mode: the code is {{code}}.",
  oc_verify: "Sign in",
  oc_back: "Back",
  oc_login_failed: "Wrong email or password.",
  oc_code_failed: "Invalid or expired code.",
  oc_network_error: "Server unreachable. Try again.",
  oc_logout: "Sign out",
  oc_nav_overview: "Overview",
  oc_nav_requests: "Lawyer requests",
  oc_nav_lawyers: "Lawyers",
  oc_nav_users: "Users",
  oc_nav_questions: "Questions",
  oc_refresh: "Refresh",
  oc_search: "Search",
  oc_all: "All",
  oc_loading: "Loading…",
  oc_empty: "Nothing to show.",
  oc_error: "Loading failed.",
  oc_retry: "Retry",
  oc_page: "Page {{page}} of {{pages}}",
  oc_prev: "Previous",
  oc_next: "Next",
  oc_results: "{{count}} results",
  oc_cancel: "Cancel",
  oc_confirm: "Confirm",
  oc_reason: "Reason (sent by email)",
  oc_reason_required: "Please give a reason.",
  oc_saved: "Saved.",
  oc_action_failed: "Action failed: {{message}}",
  oc_view_profile: "View profile",
  oc_status_pending: "Pending",
  oc_status_approved: "Approved",
  oc_status_rejected: "Rejected",
  oc_status_published: "Published",
  oc_status_closed: "Closed",
  oc_ov_title: "Overview",
  oc_ov_updated: "Updated at {{time}}",
  oc_ov_pending_requests: "Pending lawyer requests",
  oc_ov_pending_questions: "Questions to review",
  oc_ov_users: "Registered users",
  oc_ov_lawyers_published: "Published lawyers",
  oc_ov_unanswered: "Published questions with no answer",
  oc_ov_appointments_pending: "Pending appointments",
  oc_ov_weekly: "Activity over the last 12 weeks",
  oc_ov_signups: "Sign-ups",
  oc_ov_questions: "Questions asked",
  oc_ov_appointments: "Appointments requested",
  oc_ov_answers: "Lawyer answers",
  oc_ov_week_of: "Week of {{date}}",
  oc_ov_total_12w: "{{count}} in 12 weeks",
  oc_ov_show_table: "Show table",
  oc_ov_hide_table: "Hide table",
  oc_ov_week: "Week",
  oc_ov_count: "Count",
  oc_ov_by_state: "Published lawyers by governorate",
  oc_ov_top_viewed: "Most viewed profiles",
  oc_ov_views: "{{count}} views",
  oc_ov_calls: "{{count}} calls",
  oc_ov_content: "Content",
  oc_ov_questions_status: "Questions",
  oc_ov_appointments_status: "Appointments",
  oc_ov_articles: "Published articles",
  oc_ov_answers_total: "Answers",
  oc_ov_clients: "Clients",
  oc_ov_lawyer_accounts: "Lawyer accounts",
  oc_ov_suspended: "Suspended accounts",
  oc_appt_pending: "Pending",
  oc_appt_confirmed: "Confirmed",
  oc_appt_cancelled: "Cancelled",
  oc_req_submitted: "Submitted on {{date}}",
  oc_req_reviewed: "Reviewed on {{date}}",
  oc_req_account: "Account",
  oc_req_email_verified: "Email confirmed",
  oc_req_email_unverified: "Email not confirmed",
  oc_req_no_account: "No linked account",
  oc_req_duplicates: "Already in the directory?",
  oc_req_duplicates_lead: "Profiles with a similar name: check this is not a duplicate.",
  oc_req_approve: "Approve",
  oc_req_reject: "Reject",
  oc_req_approve_confirm: "Publish this profile in the directory and open the lawyer dashboard?",
  oc_req_reject_title: "Reject the request from {{name}}",
  oc_req_reject_lead: "The account becomes a client account again. The reason is emailed to the lawyer.",
  oc_req_note: "Note",
  oc_law_visibility: "Visibility",
  oc_law_published: "Published",
  oc_law_hidden: "Hidden",
  oc_law_source: "Source",
  oc_law_source_directory: "Directory",
  oc_law_source_registered: "Sign-up",
  oc_law_name: "Lawyer",
  oc_law_state: "Governorate",
  oc_law_stats: "Audience",
  oc_law_status: "Status",
  oc_law_actions: "Actions",
  oc_law_hide: "Hide",
  oc_law_publish: "Publish",
  oc_law_plan: "Plan",
  oc_law_plan_free: "Free",
  oc_law_offer_pro: "Offer Pro",
  oc_law_remove_pro: "Remove Pro",
  oc_plan_trialing: "Pro · trial",
  oc_plan_active: "Pro",
  oc_plan_past_due: "Pro · unpaid",
  oc_plan_comped: "Pro (offered)",
  oc_plan_legacy: "Pro (legacy, no subscription)",
  oc_plan_expired: "Free (former Pro)",
  oc_plan_until: "until {{date}}",
  oc_plan_ends: "ends {{date}}",
  oc_ov_pro_title: "Pro subscriptions",
  oc_ov_pro_mrr: "Monthly revenue",
  oc_ov_pro_active: "Paying",
  oc_ov_pro_trialing: "On trial",
  oc_ov_pro_past_due: "Payment overdue",
  oc_ov_pro_comped: "Offered",
  oc_law_hide_confirm: "Remove {{name}} from the public directory?",
  oc_law_publish_confirm: "Publish {{name}} in the public directory?",
  oc_law_publish_warn_not_in_onat: "Warning: this lawyer is not on the current ONAT register (retired, deceased or not matched). Only publish if you have checked they practise.",
  oc_law_publish_warn_left_onat: "Warning: this lawyer is no longer listed as active on the ONAT register. Only publish if you have checked they practise.",
  oc_law_not_in_onat: "Not in ONAT register",
  oc_law_left_onat: "Left ONAT register",
  oc_user_reactivate: "Reactivate account",
  oc_user_reactivate_confirm: "Reactivate {{name}}'s account? They will be able to sign in again.",
  oc_law_search_ph: "Name, email, phone or registration no.",
  oc_usr_name: "User",
  oc_usr_role: "Role",
  oc_usr_role_guest: "Client",
  oc_usr_role_lawyer: "Lawyer",
  oc_usr_joined: "Joined",
  oc_usr_activity: "Activity",
  oc_usr_activity_value: "{{questions}} questions · {{appointments}} appts",
  oc_usr_status: "Status",
  oc_usr_active: "Active",
  oc_usr_suspended: "Suspended",
  oc_usr_unverified: "Email not confirmed",
  oc_usr_filter_suspended: "Suspended",
  oc_usr_filter_unverified: "Email not confirmed",
  oc_usr_suspend: "Suspend",
  oc_usr_unsuspend: "Reactivate",
  oc_usr_verify: "Confirm email",
  oc_usr_suspend_confirm: "Suspend {{name}}'s account? They will no longer be able to sign in.",
  oc_usr_verify_confirm: "Confirm {{name}}'s email address without the emailed link?",
  oc_usr_search_ph: "Name, email or phone",
  oc_q_by: "By {{name}}",
  oc_q_answers: "{{count}} answers",
  oc_q_publish: "Publish",
  oc_q_publish_confirm: "Publish this question on the site? \"{{title}}\"",
  oc_q_reject: "Reject",
  oc_q_reject_title: "Reject the question “{{title}}”",
  oc_q_reject_lead: "The question stays private. The reason is emailed to its author, who can edit it.",
  oc_q_lang_ar: "Arabic",
  oc_q_lang_fr: "French",
  oc_q_search_ph: "Title or content",
  oc_q_open: "Open page",
  oc_nav_articles: "Articles",
  oc_art_status_pending: "Drafts",
  oc_art_status_published: "Published",
  oc_art_status_deleted: "Unpublished",
  oc_art_lang_en: "English",
  oc_art_search_ph: "Title or summary",
  oc_art_created_on: "Drafted {{date}}",
  oc_art_published_on: "Published {{date}}",
  oc_art_unpublished_on: "Unpublished {{date}}",
  oc_art_preview: "Preview the article",
  oc_art_hide: "Hide the preview",
  oc_art_view: "View on site",
  oc_art_unpublish: "Unpublish",
  oc_art_publish_title: "Publish “{{title}}”?",
  oc_art_publish_lead: "The article goes live on the magazine and is dated today if it has never been published.",
  oc_art_unpublish_title: "Unpublish “{{title}}”",
  oc_art_unpublish_lead: "The article is removed from the site. The reason is kept with it for the team.",
  // ?Look for a lawyer component
  Why_make_an_appointment_with_AvoConsulte:
    "Why make an appointment with AvoConsulte?",
  Why_make_an_appointment_with_AvoConsulte_description:
    "With AvoConsulte, make an online appointment with your Lawyer in another way",
  LOOK_FOR_A_LAWYER: "LOOK FOR A LAWYER",
  LOOK_FOR_A_LAWYER_DESCRIPTION: "Get a quick access to your lawyer",
  SEE_PROFILE: "SEE PROFILE",
  SEE_PROFILE_DESCRIPTION: "Make an appointment online at any time",
  TAKE_HIS_CONTACT_INFORMATION: "TAKE HIS CONTACT INFORMATION",
  TAKE_HIS_CONTACT_INFORMATION_DESCRIPTION:
    "Receive personalized mail reminders",
  // ?Question section component
  Legal_advice: "Legal Advice",
  Legal_advice_description:
    "Ask the lawyer your question and review the list of questions and their answers.",
  View_All_question: "View All Questions",
  Share_the_post: "Share the post",
  Answers: "Answers",
  Answer_as_a_lawyer: "Answer as a lawyer",
  Answer_Question: "Answer Question",
  Answer: "Answer",
  //(home page) Blog section component
  Legal_Magazine_title: "Legal Magazine",
  Legal_Magazine_description:
    "The legal magazine of our platform contains useful information and all the news",
  View_All_blog: "View All Blogs",
  No_content_available: "No content available",
  blog_is_not_available: "Blog is not available",
  // ?footer component
  AvoConsulte: "AvoConsulte",
  All_rights_reserved: "All rights reserved",
  Looking_for_a_lawyer: "Looking for a lawyer ?",
  Register_as_Client: "Register as Client",
  Register_as_Lawyer: "Register as Lawyer",
  POPULAR_SEARCHES: "POPULAR SEARCHES",
  Lawyer_Tunis: "Lawyer tunis",
  Lawyer_Ariana: "Lawyer Ariana",
  Lawyer_Sfax: "Lawyer Sfax",
  Lawyer_Sousse: "Lawyer Sousse",
  Lawyer_Manouba: "Lawyer Manouba",
  Lawyer_Monastir: "Lawyer Monastir",
  Lawyer_Mahdia: "Lawyer Mahdia",
  Lawyer_Nabeul: "Lawyer Nabeul",
  Lawyer_Kairouan: "Lawyer Kairouan",
  Lawyer_Kasserine: "Lawyer Kasserine",
  Lawyer_Gabes: "Lawyer Gabes",
  Lawyer_Medenine: "Lawyer Medenine",
  Lawyer_Sidi_Bouzid: "Lawyer Sidi Bouzid",
  Lawyer_Siliana: "Lawyer Siliana",
  Lawyer_Gafsa: "Lawyer Gafsa",
  Lawyer_Jendouba: "Lawyer Jendouba",
  Lawyer_Kebili: "Lawyer Kebili",
  Lawyer_Zaghouan: "Lawyer Zaghouan",
  Lawyer_Bizerte: "Lawyer Bizerte",
  Lawyer_Ben_arous: "Lawyer ben arous",
  Lawyer_beja: "Lawyer Beja",
  Lawyer_Tozeur: "Lawyer Tozeur",
  //Question page component
  Load_More: "Load More",
  Latest_Posts: "Latest Posts",
  //Lawyers page component
  No_lawyer_found: "No lawyer found",
  View_Profile: "View Profile",
  Book_Appointment: "Book Appointment",
  Search_Filter: "Search Filter",
  Phone_numbers: "Phone numbers",
  Lawyers_p: "Lawyers",
  Description_Lawyer_p:
    "Find the best lawyers and book your appointment online.",
  //Lawyer profile page component
  Phone_number: "Phone number",
  Lawyer_Contact_information: "Lawyer Contact information",
  Close: "Close",
  Not_Available: "Not Available",
  Overview: "Overview",
  Business_Hours: "Business Hours",
  hours_lead: "Set the days and hours you receive clients. Clients can only book inside these hours, in one-hour appointments.",
  hours_open: "Open",
  hours_morning: "Morning",
  hours_afternoon: "Afternoon",
  hours_continuous: "Hours",
  hours_from: "from",
  hours_to: "to",
  hours_lunch_break: "Lunch break",
  hours_copy_monday: "Apply Monday's hours to Tuesday–Friday",
  hours_save: "Save hours",
  hours_saved: "Hours saved. Booking slots are up to date.",
  hours_save_error: "Saving failed. {{message}}",
  hours_error_order: "The end time must be after the start time.",
  hours_error_overlap: "The afternoon must start after the morning ends.",
  booking_pick_slot: "Choose a time slot",
  booking_prev_week: "Previous week",
  booking_next_week: "Next week",
  booking_unavailable: "unavailable",
  booking_no_slots_week: "No free slot this week. Try the next week.",
  booking_selected: "Selected slot: {{day}} {{date}}, {{time}}",
  pro_offer_title: "Run your whole practice with AvoConsulte Pro",
  pro_offer_lead: "Online booking, calendar, client case files and shared notes, in one place. Less time on the phone, more time for your cases.",
  pro_ended_note: "Pro is paused on your account. Your cases, notes and statistics are kept: resume Pro to get them back.",
  pro_f_booking: "Online booking, 24/7",
  pro_f_booking_text: "Clients book themselves within your opening hours, even evenings and weekends. You confirm in one click.",
  pro_f_agenda: "Practice calendar",
  pro_f_agenda_text: "Requests, confirmed appointments and time off in a single calendar.",
  pro_f_stats: "Practice statistics",
  pro_f_stats_text: "Cases opened and closed, appointments, profile views and calls over 30 days.",
  pro_f_address: "Custom address",
  pro_f_address_text: "A short link with your name to share on your cards and social media.",
  pro_f_cases: "Client case files",
  pro_f_cases_text: "One file per matter, with reference, status and encrypted private notes.",
  pro_f_shared: "Notes shared with the client",
  pro_f_shared_text: "Share one specific note (documents to bring, hearing date): your client reads it in their space. Everything else stays private.",
  pro_f_clients: "Client records",
  pro_f_clients_text: "Appointment history and a private memo for each client.",
  pro_f_feedback: "Private client feedback",
  pro_f_feedback_text: "After each consultation, the client can leave feedback that only you read. Never published.",
  pro_trial_no_card: "No bank card needed",
  pro_trial_no_charge: "Nothing is charged: the trial simply ends on {{date}}",
  pro_trial_keep_data: "Subscribe whenever you like and keep everything you created",
  pro_consent_after_trial: "I understand: {{price}} TND will be charged today for a first month starting on {{date}}, when my trial ends, then every month until I cancel.",
  pro_cta_keep: "Keep Pro — {{price}} TND / month",
  pro_fine_after_trial: "You don't lose any trial days. Secure payment via Flouci, no commitment.",
  pro_trial_notice: "Your trial ends on {{date}}. No card is on file and nothing will be charged: without a subscription, your account simply goes back to the free plan.",
  pro_c_phone: "Phone number",
  pro_c_office: "Office address",
  pro_c_cases: "Client case files and private notes",
  pro_c_shared: "Notes shared with your clients",
  pro_c_clients: "Client records and memos",
  pro_c_feedback: "Private client feedback",
  pro_compare_note: "Directory order and lawyer suggestions never depend on the plan: they follow the Bar's roll.",
  booking_tag: "Books online",
  pro_per_month: "TND / month",
  pro_roi: "Less than 2 TND a day, no commitment.",
  pro_consent_paid: "I understand: {{price}} TND will be charged today, then every month until I cancel.",
  pro_cta_trial: "Try Pro free for {{days}} days",
  pro_cta_paid: "Subscribe to Pro — {{price}} TND / month",
  pro_fine_paid: "Secure payment via Flouci. No commitment: cancel any time, Pro stays on until the end of the paid month.",
  pro_test_mode: "Test mode: no real payment, Flouci is not connected yet.",
  pro_compare_title: "Free or Pro",
  pro_plan_free: "Free",
  pro_c_profile: "Directory profile",
  pro_c_hours: "Opening hours",
  pro_c_answers: "Answer legal questions",
  pro_c_booking: "Online booking",
  pro_c_agenda: "Calendar and request handling",
  pro_c_stats: "Practice and profile statistics",
  pro_c_address: "Custom address",
  pro_yes: "Included",
  pro_no: "Not included",
  pro_status_trialing: "Free trial — {{count}} days left",
  pro_status_active: "You are Pro",
  pro_status_canceling: "Pro until {{date}}",
  pro_status_past_due: "Payment pending",
  pro_status_comped: "Pro offered by AvoConsulte",
  pro_next_charge: "Next payment: {{price}} TND on {{date}} to {{card}}.",
  pro_canceling_notice: "Your subscription will not renew and nothing will be charged. You keep Pro until {{date}}.",
  pro_past_due_notice: "The {{price}} TND payment was declined. Update your card before {{date}} to keep Pro; we also retry every day.",
  pro_comped_notice: "The AvoConsulte team is offering you Pro. You will not be asked to pay.",
  pro_card_on_file: "Card on file: {{card}}",
  pro_update_card: "Change card",
  pro_resume: "Resume my subscription",
  pro_cancel: "Cancel subscription",
  pro_cancel_confirm: "Cancel? Pro stays active until {{date}}, then won't renew.",
  pro_cancel_yes: "Yes, cancel",
  pro_cancel_keep: "Keep Pro",
  pro_cancel_done: "Cancellation saved. A confirmation email has been sent.",
  pro_resume_done: "Your subscription continues.",
  pro_welcome_trial: "Welcome to Pro! Your {{days}}-day trial has started, with no card and no commitment. A summary email has been sent to you.",
  pro_welcome_paid: "Welcome to Pro! Your payment was accepted.",
  pro_card_failed: "The card could not be verified.",
  pro_checkout_unavailable: "Online payment is not available right now.",
  pro_action_failed: "The action failed. Try again.",
  err_too_many_requests: "Too many attempts in a short time. Wait a little and try again.",
  lawyer_registry_fields_note: "Your name and governorate come from the ONAT register and cannot be changed here. To correct them, contact us.",
  pro_load_error: "Could not load your subscription. Try again later.",
  pro_confirming: "Checking…",
  pro_invoices: "Payments",
  pro_inv_date: "Date",
  pro_inv_period: "Period",
  pro_inv_amount: "Amount",
  pro_inv_status: "Status",
  pro_inv_paid: "Paid",
  pro_inv_failed: "Declined",
  pro_payment_soon_title: "Online payment coming soon",
  pro_payment_soon: "Online Pro subscriptions are coming soon: card payment is not open yet. You won't be asked to pay anything until then.",
  pro_banner_trial_ending_free: "Your Pro trial ends in {{count}} days, on {{date}}. Your account then returns to the free plan, with no charge.",
  pro_err_card_declined: "The card was declined by the bank.",
  pro_err_card_expired: "The card has expired.",
  pro_err_payment_failed: "The bank declined the payment. Nothing was charged; you can try again with another card.",
  pro_err_in_progress: "A payment is already being processed. Please wait a few minutes before trying again.",
  pro_err_session: "This payment session has expired. Start again from your dashboard.",
  pro_err_already_pro: "You already have Pro.",
  pro_err_trial_used: "The free trial has already been used on this profile.",
  pro_err_trial_not_cancelable: "The free trial ends on its own, with no charge: there is nothing to cancel.",
  pro_err_no_subscription: "No subscription in progress.",
  pro_err_profile: "Your lawyer profile must first be approved by the team.",
  pro_inv_pending: "Processing",
  pro_inv_checking: "Being checked",
  pro_banner_trial_ending: "Your Pro trial ends in {{count}} days, on {{date}}. Subscribe to keep online booking and your case files ({{price}} TND / month).",
  pro_banner_past_due: "Pro payment declined. Update your card before {{date}} to keep your benefits.",
  pro_banner_manage: "Manage",
  pro_menu_subscription: "My Pro subscription",
  pro_menu_upgrade: "Go Pro",
  pro_locked_hint: "Included in AvoConsulte Pro",
  pro_stats_title: "Your audience over 30 days",
  pro_stats_views: "Profile views",
  pro_stats_calls: "Calls",
  pro_stats_bookings: "Booking requests",
  pro_stats_locked: "See how many clients view your profile, call you and request an appointment.",
  pro_stats_unlock: "Unlock with Pro",
  pro_stats_note: "Compared with the previous 30 days.",
  pro_sbx_banner: "Test mode — no real payment. Flouci's page will replace this one.",
  pro_sbx_title: "Card verification",
  pro_sbx_lead: "The first month is charged as soon as the card is verified. You can cancel any time.",
  pro_sbx_card_number: "Card number",
  pro_sbx_expiry: "Expiry",
  pro_sbx_name: "Name on card",
  pro_sbx_submit: "Verify my card",
  pro_sbx_test_cards: "Test cards",
  pro_sbx_card_ok: "accepted",
  pro_sbx_card_fails_later: "accepted, but payments fail",
  pro_sbx_card_declined: "declined",
  no_further_information: "There's no further information on",
  No_busniess_hours_specified: "No busniess hours specified",
  Open_Now: "Open Now",
  Closed_Now: "Closed Now",
  Closed: "Closed",
  appel: "Lawyer in the Court of Appeal",
  cassation: "Lawyer at the Court of Cassation",
  permiere: "Lawyer in the first instance",
  premiere: "Lawyer in the first instance",
  Today: "Today",
  Education: "Work & education",
  Services: "Services",
  // ?about us Page component
  What_is_AvoConsulte: "What is AvoConsulte ?",
  Avoconsulte_AboutUs_p1:
    "Avoconsulte is a quick and easy platform to make an appointment with a lawyer available near you from the lawyer directory to meet your needs",
  For_customers: "For customers",
  For_customers_p1:
    "AvoConsulte is an innovative platform that allows you to quickly find a lawyer near you and make an appointment online for free.",
  For_customers_p2:
    "AvoConsulte allows you to put your questions online directly to attorneys while respecting confidentiality terms.",
  For_customers_p3:
    "AvoConsulte lets you find answers online to your questions, given directly by qualified lawyers.",
  For_legal_professionals: "For legal professionals",
  For_legal_professionals_p1:
    "AvoConsulte is a comprehensive law firm management service that improves your organization and saves you time.",
  For_legal_professionals_p2:
    ", a complete cab management service, you share your availability in real time with your clients based on your criteria, while maintaining control of your statutory agenda, improving your organization and saving you time.",
  For_legal_professionals_p3:
    "allows you to communicate directly with clients and answer their questions.",
  With: "With",
  Testimonials: "Testimonials",
  Checkout_what_people_think_about_Us: "Checkout what people think about Us",
  Contact_us_for_further_information_or_assistance:
    "Contact us for further information or assistance",
  Email: "Email",
  Phone: "Phone",
  Location: "Location",
  Get_in_touch: "Get in touch",
  Your_Name: "Your Name",
  Your_Email: "Your Email",
  Subject: "Subject",
  Message: "Message",
  Send_Message: "Send Message",
  Thank_you_for_reaching_out_to_us: "Thank you for reaching out to us",
  //login page component
  Password: "Password",
  Forgot_Password: "Forgot Password",
  or: "or",
  Dont_have_an_account: "Don't have an account?",
  Are_you_a_Lawyer: "Are you a Lawyer?",
  Register_here: "Register",
  login_password_Required: "Password is Required",
  login_email_Invalid: "Email is Invalid",
  login_email_Required: "Email is Required",
  login_failed: "Login failed",
  //register page component
  Register: "Register",
  Mobile_Number: "Mobile Number",
  Create_Password: "Create Password",
  Confirm_Password: "Confirm Password",
  Already_have_an_account: "Already have an account?",
  Signup: "Signup",
  Full_Name: "Full Name",
  First_Name: "First Name",
  Last_Name: "Last Name",
  Date_of_birth: "Date of birth",
  register_first_Name_Required: "First Name is Required",
  register_last_Name_Required: "Last Name is Required",
  register_email_Invalid: "Email is Invalid",
  register_email_Required: "Email is Required",
  register_password_MinLength: "Password must be at least 8 characters long",
  register_password_Required: "Password is Required",
  register_passwordMatch: "Password and Confirm Password must match",
  register_confirm_Password_Required: "Confirm Password is Required",
  register_dob_Required: "Date of birth is Required",
  Register_failed: "Register failed",
  This_email_is_linked_to_another_account:
    "This email is linked to another account",
  //Dashboard
  your_profile_has_been_updated_successfully:
    "Your profile has been updated successfully",
  error_occurred_while_updating_your_profile:
    "Error occurred while updating your profile",
  Dashboard: "Dashboard",
  My_Dashboard: "My Dashboard",
  Profile_Settings: "Profile Settings",
  photo_uploading: "Uploading photo…",
  photo_error_type: "That image can't be read. Choose a JPG, PNG or WebP photo.",
  photo_error_upload: "The photo couldn't be uploaded. Please try again.",
  Logout: "Logout",
  Appointments: "Appointments",
  Ask_Question: "Ask Question",
  My_Questions: "My Questions",
  Appt_Date: "Appt Date",
  Booking_Date: "Booking Date",
  Booking_type: "Booking type",
  Status: "Status",
  Lawyer: "Lawyer",
  You_havent_book_any_appointmen_yet: "You haven't book any appointmen",
  You_havent_asked_any_question_yet: "You haven't asked any question",
  Question_Title: "Question Title",
  Question_Description: "Question Description",
  ID: "ID",
  Date: "Date",
  Title: "Title",
  Password_Security: "Password & Security",
  Old_password: "Old password",
  enter_your_old_password: "Enter your old password",
  New_password: "New password",
  enter_your_new_password: "Enter your new password",
  Confirm_new_password: "Confirm new password",
  confirm_your_new_password: "Confirm your new password",
  Save_Changes: "Save Changes",
  Personal_Information: "Personal Information",
  Services_and_Educations_Information: "Services and Education",
  View: "View",
  Accept: "Accept",
  Cancel: "Cancel",
  Edit: "Edit",
  Delete: "Delete",
  Review: "Review",
  Change_Password: "Change Password",
  password_has_been_changed_successfully:
    "Password has been changed successfully",
  error_occurred_while_changing_your_password:
    "Error occurred while changing your password",
  pending: "Pending",
  accepted: "Accepted",
  confirmed: "Confirmed",
  rejected: "Rejected",
  cancelled: "Cancelled",
  Edite_Question: "Edite Question",
  Become_Lawyer: "Become a Lawyer",
  Name_in_arabic: "Name in arabic",
  Name_in_french: "Name in french",
  Address_in_arabic: "Address in arabic",
  Address_in_french: "Address in french",
  Delegation: "Delegation",
  Ask_Another_Question: "Ask Another Question",
  your_account_is_under_review: "Your account is under review",
  review_your_application:
    "you will receive an email as soon as we review your application, thank you for using our services",
  error_occurred_while_submitting_your_application:
    "Error occurred while submitting your application",

  //Account verification
  Your_account_has_been_verified_successfully:
    "Your account has been verified successfully",
  error_occurred_while_verifying_your_account:
    "Error occurred while verifying your account",
  verifying: "Verifying",
  verification: "Verification",
  very_nice_you_made_it: "Very nice! You made it !!",
  go_to_login: "Go to login",
  this_is_not_your_correct_email: "This is not your correct email",
  Check_your_email_for_the_verification_link:
    "Check your email for the verification link",
  Verify_your_account_please: "Verify your account please",
  Change_email: "Change email",
  you_are_already_using_this_email: "You are already using this email",
  something_went_wrong_please_try_again:
    "Something went wrong please try again",
  //Lawyer dashboard
  Social_Media: "Social Media",
  Messages: "Messages",
  Accounts: "Accounts",
  Invoices: "Invoices",
  Available_Timings: "Business hours",
  Schedule_Timings: "calendar",
  Clients: "Clients",
  Today_Appointments: "Today Appointments",
  My_Answers: "My Answers",
  You_dont_have_any_appointmen_yet: "You don't have any appointmen",
  Today_Clients: "Today Clients",
  Total_Clients: "Total Clients",
  Appoinments: "Appoinments",
  You_havent_answered_any_question_yet: "You haven't answered any question",
  profile_update_failed: "Profile update failed",
  profile_update_success: "Profile update success",
  Update: "Update",
  Appointment_Details: "Appointment Details",
  End_Time: "End Time",
  Start_Time: "Start Time",
  you_dont_have_any_appointment: "You don't have any appointment ",
  Till_Today: "Till Today",
  in_Person: "In Person",
  Client: "Client",
  add_event: "Add Event",
  startDate: "Start Date",
  endDate: "End Date",
  //booking page
  Book_now: "Book now",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",
  Thank_You: "Thank You",
  error_while_schudling_your_appointement:
    "Error while schudling your appointement",
  subject_is_required: "Subject is required",
  description_is_required: "Description is required",
  time_is_required: "Time is required",
  Booking_information: "Booking information",
  //thank you page
  Appointment_booked_Successfully: "Appointment booked Successfully",
  //lawyer register page
  Full_name: "Full name",
  Adress: "Adress",
  phone_number: "phone number",
  office_phone: "office phone",
  court: "court",
  state: "state",
  cour_d_appel: "Appellate court",
  cour_de_cassation: "Court of Comments",
  cour_a_la_permiere: "Court of First Instance",
  register_full_Name_Required: "Full name is Required",
  register_Adress_Required: "Adress is Required",
  register_phone_Required: "phone number is Required",
  register_office_Required: "office phone is Required",
  register_court_Required: "court is Required",
  register_state_Required: "state is Required",
  Choose_court: "Choose court",
  Lawyer_account_request: "Lawyer account request",
  Submit_Request: "Submit Request",
  document_upload: "document upload",
  My_Lawyer_Account: "My Lawyer Account",
  About_Me: "About Me",
  bref_description: "bref description",
  Required: "Required",
  //States
  Choose_delegation: "Choose delegation",
  Choose_state: "Choose state",
  Tunis: "Tunis",
  Ariana: "Ariana",
  Ben_Arous: "Ben Arous",
  Mannouba: "Mannouba",
  Sousse: "Sousse",
  Sfax: "Sfax",
  Nabeul: "Nabeul",
  Sidi_Bouzid: "Sidi Bouzid",
  Beja: "Beja",
  Tozeur: "Tozeur",
  Monastir: "Monastir",
  Mahdia: "Mahdia",
  Bizerte: "Bizerte",
  Kasserine: "Kasserine",
  Jendouba: "Jendouba",
  Kef: "Kef",
  Medenine: "Médenine",
  Kairouan: "Kairouan",
  Gabes: "Gabes",
  Kebili: "Kebili",
  Zaghouan: "Zaghouan",
  Siliana: "Siliana",
  Tataouine: "Tataouine",
  Gafsa: "Gafsa",
  //membership
  membership: "membership",
  you_have_premium_membership: "You have premium membership",
  you_have_free_membership: "you_have_free_membership",
  thank_you_for_choosing_avoconsulte: "Thank you for choosing Avoconsulte",
  // Editorial FAQ, topic pages and internal links
  faq_editorial_badge: "Answer by the AvoConsulte editorial team",
  faq_editorial_team: "The AvoConsulte editorial team",
  faq_editorial_note: "This answer was written by the AvoConsulte editorial team, not by a lawyer. It gives general information and does not replace advice from a lawyer who looks at your own situation.",
  faq_related_guide: "Read the full guide",
  faq_more_in_topic: "More questions on this topic",
  faq_ask_own: "Ask your own question",
  faq_ask_own_text: "Is your situation different? Ask the lawyers registered on the platform.",
  find_lawyer_title: "Find a lawyer in your city",
  find_lawyer_text: "The directory of lawyers registered with the Tunisian Bar, by governorate.",
  find_lawyer_all: "All lawyers in Tunisia",
  related_title: "Related reading",
  related_kind_guide: "Guide",
  related_kind_faq: "FAQ",
  sources_title: "Sources",
  sources_new_tab: "(opens in a new tab)",
  article_last_updated: "Last updated",
  read_in: "Read in:",
  topic_label: "Topic",
  topics_title: "Topics",
  topic_guides: "Guides",
  topic_faq: "Frequently asked questions",
  oc_q_editorial: "Editorial",
  oc_q_editorial_only: "Editorial FAQ only",
  oc_q_kind: "Type",
  oc_q_kind_visitors: "Visitors' questions",
  oc_q_editorial_answer: "Editorial team's answer",
  oc_q_editorial_by: "AvoConsulte editorial team",
  oc_q_lang_en: "English",
  page_loading: "Loading…",
};
